import blogService from './blogService';

// Sample categories data
const sampleCategories = [
  {
    name: 'Web Development',
    description: 'Articles about web development technologies and practices',
    slug: 'web-development',
    color: '#3B82F6'
  },
  {
    name: 'Design',
    description: 'UI/UX design tips and tutorials',
    slug: 'design',
    color: '#10B981'
  },
  {
    name: 'Business',
    description: 'Business insights and strategies',
    slug: 'business',
    color: '#F59E0B'
  },
  {
    name: 'Technology',
    description: 'Latest technology trends and news',
    slug: 'technology',
    color: '#8B5CF6'
  },
  {
    name: 'Tutorials',
    description: 'Step-by-step tutorials and guides',
    slug: 'tutorials',
    color: '#EF4444'
  }
];

// Sample tags data
const sampleTags = [
  {
    name: 'React',
    slug: 'react'
  },
  {
    name: 'JavaScript',
    slug: 'javascript'
  },
  {
    name: 'CSS',
    slug: 'css'
  },
  {
    name: 'HTML',
    slug: 'html'
  },
  {
    name: 'TypeScript',
    slug: 'typescript'
  },
  {
    name: 'Node.js',
    slug: 'nodejs'
  },
  {
    name: 'Firebase',
    slug: 'firebase'
  },
  {
    name: 'UI/UX',
    slug: 'ui-ux'
  },
  {
    name: 'Responsive Design',
    slug: 'responsive-design'
  },
  {
    name: 'Performance',
    slug: 'performance'
  }
];

// Function to initialize blog data
export const initializeBlogData = async () => {
  try {
    console.log('Initializing blog data...');
    
    // Get existing categories and tags
    const existingCategories = await blogService.getCategories();
    const existingTags = await blogService.getTags();
    
    console.log('Existing categories:', existingCategories.length);
    console.log('Existing tags:', existingTags.length);
    
    // Create categories if none exist
    if (existingCategories.length === 0) {
      console.log('Creating sample categories...');
      for (const category of sampleCategories) {
        try {
          await blogService.createCategory(category);
          console.log(`Created category: ${category.name}`);
        } catch (error) {
          console.error(`Error creating category ${category.name}:`, error);
        }
      }
    }
    
    // Create tags if none exist
    if (existingTags.length === 0) {
      console.log('Creating sample tags...');
      for (const tag of sampleTags) {
        try {
          await blogService.createTag(tag);
          console.log(`Created tag: ${tag.name}`);
        } catch (error) {
          console.error(`Error creating tag ${tag.name}:`, error);
        }
      }
    }
    
    console.log('Blog data initialization completed!');
    
    // Return the updated data
    const updatedCategories = await blogService.getCategories();
    const updatedTags = await blogService.getTags();
    
    return {
      categories: updatedCategories,
      tags: updatedTags
    };
  } catch (error) {
    console.error('Error initializing blog data:', error);
    throw error;
  }
};

// Function to check if blog data exists
export const checkBlogData = async () => {
  try {
    const categories = await blogService.getCategories();
    const tags = await blogService.getTags();
    
    console.log('Blog data check:');
    console.log(`- Categories: ${categories.length}`);
    console.log(`- Tags: ${tags.length}`);
    
    if (categories.length === 0) {
      console.log('No categories found. Run initializeBlogData() to create sample data.');
    }
    
    if (tags.length === 0) {
      console.log('No tags found. Run initializeBlogData() to create sample data.');
    }
    
    return { categories, tags };
  } catch (error) {
    console.error('Error checking blog data:', error);
    throw error;
  }
};

// Make functions available globally for testing
if (typeof window !== 'undefined') {
  (window as any).initializeBlogData = initializeBlogData;
  (window as any).checkBlogData = checkBlogData;
}
